import sortBy from 'lodash/sortBy';
import maxBy from 'lodash/maxBy';
import { DISPLAY_IN_TYPE } from '../../lib/displayIn';
import {
  APPLY_DIFFERENTIALS_TO_JOB_MATCHES_FAILED,
  APPLY_DIFFERENTIALS_TO_JOB_MATCHES_START,
  APPLY_DIFFERENTIALS_TO_JOB_MATCHES_SUCCESS,
  CALCULATE_PROPOSED_VALUE_FAILED,
  CALCULATE_PROPOSED_VALUE_START,
  CALCULATE_PROPOSED_VALUE_SUCCESS,
  CANCEL_CHANGES,
  CANCEL_EDIT_MATCH,
  CLEAR_GEO_DIFFERENTIAL,
  CREATE_AD_HOC_JOB_FAILED,
  CREATE_AD_HOC_JOB_START,
  CREATE_AD_HOC_JOB_SUCCESS,
  EDIT_MATCH,
  GET_CROWD_SOURCED_TITLE_MATCH_SUCCESS,
  GET_DIFFERENTIAL_FAIL,
  GET_DIFFERENTIAL_SUCCESS,
  GET_GEO_DIFFERENTIAL_FAILED,
  GET_GEO_DIFFERENTIAL_START,
  GET_GEO_DIFFERENTIAL_SUCCESS,
  GET_JOB_FAMILIES_START,
  GET_JOB_FAMILIES_SUCCESS,
  GET_JOB_LOCATIONS,
  GET_JOB_MATCHES_SUCCESS,
  GET_JOB_PRICING_SUCCESS,
  RESET_DIFFERENTIALS_TO_INITIAL_STATE,
  RESET_GEO_STATE,
  RESET_SKILLS_ERROR,
  RESET_SKILLS_STATE,
  SET_CHANGES_CANCELLED,
  SET_COMMENT,
  SET_DIFFERENTIAL_FAIL,
  SET_DIFFERENTIAL_SUCCESS,
  SET_GEO_DIFFERENTIAL_IS_REMOVED,
  SET_GEO_IS_PENDING_REMOVE,
  SET_HAS_CHANGES,
  SET_HAS_PERFORMED_CALCULATE_ACTION,
  SET_INCLUDE_COMMENT,
  SET_SELECTED_JOB_FAMILY,
  SET_SELECTED_JOB_LOCATION,
  SET_SELECTED_JOB_MATCHES,
  SET_SELECTED_JOB_TASKS,
  SET_SELECTED_JOB_TITLE,
  SET_SELECTED_SKILL_GEO_DIFFERENTIAL_DATA,
  SET_SKILL_IS_PENDING_REMOVE,
  SET_SKILLS_DIFFERENTIAL_IS_REMOVED,
  SET_TITLE,
  SKILL_DIFFERENTIAL_FAIL,
  SKILL_DIFFERENTIAL_SUCCESS,
  START_TITLE_AUTOMATCH,
  TITLE_AUTO_MATCH_FAILED,
  TITLE_AUTO_MATCH_SUCCESS,
  TOGGLE_GEO_CARD,
  TOGGLE_GEO_CARD_EXPAND,
  TOGGLE_GEO_LOCATION_ONLY,
  TOGGLE_INCLUDE_COMMENT,
  TOGGLE_SKILL,
  TOGGLE_SKILLS_CARD,
  TOGGLE_SKILLS_CARD_EXPAND,
  TOGGLE_SKILLS_SEARCH,
  UPDATE_GEO_DIFFERENTIAL_OVERRIDE,
  UPDATE_SELECTED_JOB_PRICING,
  UPDATE_SKILL_DIFFERENTIAL_OVERRIDE,
  SEND_OPPORTUNITY_EMAIL_SUCCESS,
  SEND_OPPORTUNITY_EMAIL_FAIL,
  SEND_OPPORTUNITY_EMAIL_RESET,
  INITIALIZE_DIFFERENTIALS_START,
  INITIALIZE_DIFFERENTIALS_SUCCESS,
  INITIALIZE_DIFFERENTIALS_FAIL
} from './SkillGeoDifferentialActions';
import { toLocationDisplayValue } from './helper';

const initialGeoState = {
  isAdded: false,
  isExpanded: false,
  locationOnly: true,
  jobFamilies: [],
  jobFamiliesLoading: false,
  jobLocations: [],
  differential: null,
  differentialOverride: null,
  differentialLoading: false,
  differentialFailed: false,
  isRemoved: false,
  isApplied: false,
  sampleSize: null,
  selectedJobFamily: null,
  selectedJobLocation: null,
  isPendingRemove: false,
  showRequestFailure: false,
  showRequestSuccess: false
};

const initialSkillsState = {
  isAdded: false,
  isExpanded: true,
  autoMatchLoading: false,
  autoMatchLoaded: false,
  isEditing: false,
  selectedJobTitle: null,
  allSkills: [],
  selectedSkills: [],
  skillsError: '',
  skillsLoaded: false,
  sampleSize: null,
  differential: null,
  differentialOverride: null,
  differentialLoading: false,
  differentialFailed: false,
  isRemoved: false,
  isApplied: false,
  isInitialLoad: false,
  isPendingRemove: false,
  adHocJob: null,
  showSearch: true
};

export const initialState = {
  orgJobId: null,
  orgJobCode: null,
  orgJobCodeKey: null,
  currency: null,
  jobTitle: null,
  benchmarkYear: null,
  jobPricing: null,
  selectedJobPricing: null,
  applyingDifferentialsToJobMatches: false,
  applyingDifferentialsToJobMatchesFailed: false,
  jobMatches: [],
  geo: { ...initialGeoState },
  skills: { ...initialSkillsState },
  pricingType: null,
  selectedJobMatches: [],
  isSelectingJobMatches: false,
  isPayScaleMatch: false,
  comment: '',
  includeComment: false,
  isDifferentialLoaded: false,
  differentialError: null,
  isDifferentialSet: false,
  createAdHocJobFailed: false,
  hasPerformedCalculateAction: false,
  pricingFieldPk: null,
  proposedValues: null,
  isCalculatingProposedValues: false,
  displayIn: DISPLAY_IN_TYPE.ANNUAL,
  crowdSourcedTitleMatchJobFamily: null,
  hasChanges: false,
  changesCancelled: false,
  jobMatchesLoaded: false,
  hasPreviousDifferential: false,
  creatingAdHocJob: false,
  hasInitializedJob: false,
  isInitializingDifferentials: false
};

export const PRICING_TYPE = {
  PRICED: 'priced',
  SLOTTED: 'slotted'
};

export const DIFFERENTIAL_TYPE = {
  SKILL: 'SKILL',
  GEO: 'GEO'
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_DIFFERENTIAL_SUCCESS:
      return {
        ...state,
        isDifferentialSet: true
      };
    case SET_DIFFERENTIAL_FAIL:
      return {
        ...state,
        isDifferentialSet: false,
        differentialError: action.error
      };
    case SET_SELECTED_JOB_TASKS:
      return {
        ...state,
        skills: {
          ...state.skills,
          tasks: action.data.tasks
        }
      };
    case GET_DIFFERENTIAL_SUCCESS:
      const geoDifferential =
        action.result.geoDifferential === 0 && !action.result.jobLocationCity ? null : action.result.geoDifferential;
      return {
        ...state,
        selectedJobMatches: action.result.selectedJobMatches,
        benchmarkYear: action.result.benchmarkYear,
        selectedJobTitle: action.result.matchTitle,
        orgJobCode: action.result.orgJobCode,
        orgJobCodeKey: action.result.orgJobCodeKey,
        orgJobId: action.result.orgJobId,
        comment: action.result.comment,
        includeComment: !!action.result.comment.length,
        isDifferentialLoaded: true,
        differentialError: null,
        hasPreviousDifferential: !!geoDifferential || !!action.result.skillDifferential,
        geo: {
          ...state.geo,
          differential: geoDifferential,
          differentialOverride: geoDifferential,
          selectedJobFamily: action.result.jobFamily,
          selectedJobLocation: toLocationDisplayValue(action.result.jobLocationCity, action.result.jobLocationState),
          isAdded: !!geoDifferential,
          isExpanded: false,
          locationOnly: !(action.result.jobFamily && action.result.jobLocationCity && action.result.jobLocationState),
          isApplied: !!geoDifferential
        },
        skills: {
          ...state.skills,
          selectedSkills: action.result.selectedSkills ? action.result.selectedSkills : [],
          differential: action.result.skillDifferential,
          differentialOverride: action.result.skillDifferential,
          selectedJobTitle: action.result.matchTitle,
          autoMatchLoading: false,
          autoMatchLoaded: true,
          isPayScaleMatch: true,
          isAdded: !!action.result.skillDifferential,
          isExpanded: false,
          isApplied: !!action.result.skillDifferential
        }
      };
    case GET_DIFFERENTIAL_FAIL:
      return {
        ...state,
        isDifferentialLoaded: false,
        differentialError: action.error
      };
    case RESET_SKILLS_ERROR:
      return {
        ...state,
        skills: {
          ...state.skills,
          skillsError: ''
        }
      };
    case TOGGLE_SKILL:
      const { allSkills, selectedSkills } = state.skills;
      const isSkillSelected = selectedSkills.includes(action.data.skill);
      let newSelectedSkills, differential;

      if (!!selectedSkills.length && isSkillSelected) {
        newSelectedSkills = allSkills.filter(
          skill => selectedSkills.includes(skill.skill) && skill.skill !== action.data.skill
        );
      } else {
        const currentSelectedSkills = allSkills.filter(skill => selectedSkills.includes(skill.skill));
        newSelectedSkills = [...currentSelectedSkills, action.data];
      }

      differential = maxBy(newSelectedSkills, skill => skill.payDifferentialPercentage);

      const differentialValue = newSelectedSkills.length
        ? parseFloat((differential.payDifferentialPercentage * 0.01).toFixed(3))
        : null;

      return {
        ...state,
        skills: {
          ...state.skills,
          selectedSkills: sortBy(newSelectedSkills, ['payDifferentialPercentage', 'skill'])
            .reverse()
            .map(skill => skill.skill),
          differential: differentialValue,
          differentialOverride: differentialValue
        }
      };
    case SKILL_DIFFERENTIAL_SUCCESS:
      const sortedSkills = sortBy(action.result, ['payDifferentialPercentage', 'skill']);
      const sampleSize = action.result.reduce((memo, skill) => (memo += skill.profileCount), 0);
      const currentlySelectedSkills = sortedSkills.filter(skill => state.skills.selectedSkills.includes(skill.skill));

      return {
        ...state,
        skills: {
          ...state.skills,
          allSkills: sortedSkills.reverse(),
          selectedSkills: currentlySelectedSkills.map(skill => skill.skill),
          skillsLoaded: true,
          sampleSize: sampleSize,
          isEditing: false,
          showSearch: false
        }
      };
    case SKILL_DIFFERENTIAL_FAIL:
      return {
        ...state,
        skills: {
          ...state.skills,
          skillsError: action.error,
          skillsLoaded: true,
          isEditing: true,
          showSearch: false
        }
      };
    case EDIT_MATCH:
      return {
        ...state,
        skills: {
          ...state.skills,
          isEditing: true,
          showSearch: true
        }
      };
    case CANCEL_EDIT_MATCH:
      return {
        ...state,
        skills: {
          ...state.skills,
          isEditing: false,
          showSearch: false
        }
      };
    case SET_TITLE:
      return {
        ...state,
        skills: {
          ...state.skills,
          selectedJobTitle: action.data,
          isAdded: true,
          isEditing: false,
          showSearch: false,
          allSkills: [],
          selectedSkills: [],
          sampleSize: null,
          differential: null,
          isPayScaleMatch: true
        }
      };
    case START_TITLE_AUTOMATCH:
      return {
        ...state,
        skills: {
          ...state.skills,
          autoMatchLoading: true
        }
      };

    case TITLE_AUTO_MATCH_SUCCESS:
      return {
        ...state,
        skills: {
          ...state.skills,
          selectedJobTitle: action.result,
          autoMatchLoading: false,
          autoMatchLoaded: true,
          isPayScaleMatch: !!action.result
        }
      };

    case TITLE_AUTO_MATCH_FAILED:
      return {
        ...state,
        skills: {
          ...state.skills,
          autoMatchLoading: false
        }
      };
    case TOGGLE_GEO_LOCATION_ONLY:
      const nextGeoLocationOnlyState = !state.geo.locationOnly;
      let jobFamily = null;
      if (nextGeoLocationOnlyState === false) {
        jobFamily = getSelectedJobFamily(
          state.geo.selectedJobFamily,
          state.crowdSourcedTitleMatchJobFamily,
          state.geo.jobFamilies
        );
      }
      return {
        ...state,
        geo: {
          ...state.geo,
          locationOnly: nextGeoLocationOnlyState,
          selectedJobFamily: jobFamily
        }
      };
    case TOGGLE_GEO_CARD: {
      return {
        ...state,
        geo: {
          ...state.geo,
          isAdded: !state.geo.isAdded,
          isExpanded: true
        }
      };
    }
    case TOGGLE_GEO_CARD_EXPAND: {
      return {
        ...state,
        geo: {
          ...state.geo,
          isExpanded: !state.geo.isExpanded
        }
      };
    }
    case TOGGLE_SKILLS_CARD:
      return {
        ...state,
        skills: {
          ...state.skills,
          isAdded: !state.skills.isAdded,
          isExpanded: true
        }
      };
    case TOGGLE_SKILLS_CARD_EXPAND:
      return {
        ...state,
        skills: {
          ...state.skills,
          isExpanded: !state.skills.isExpanded
        }
      };
    case GET_JOB_FAMILIES_START:
      return {
        ...state,
        geo: {
          ...state.geo,
          jobFamiliesLoading: true
        }
      };
    case GET_JOB_FAMILIES_SUCCESS:
      let geoJobFamily = state.geo.selectedJobFamily;
      if (!state.geo.locationOnly) {
        geoJobFamily = getSelectedJobFamily(geoJobFamily, state.crowdSourcedTitleMatchJobFamily, action.jobFamilies);
      }
      return {
        ...state,
        geo: {
          ...state.geo,
          jobFamilies: action.jobFamilies,
          jobFamiliesLoading: false,
          selectedJobFamily: geoJobFamily
        }
      };
    case GET_JOB_LOCATIONS:
      return {
        ...state,
        geo: {
          ...state.geo,
          jobLocations: action.jobLocations
        }
      };
    case GET_GEO_DIFFERENTIAL_START:
      return {
        ...state,
        geo: {
          ...state.geo,
          differentialLoading: true
        }
      };
    case GET_GEO_DIFFERENTIAL_SUCCESS:
      return {
        ...state,
        geo: {
          ...state.geo,
          differential: action.geoDifferential,
          differentialOverride: action.retainCurrentOverride ? state.geo.differentialOverride : action.geoDifferential,
          sampleSize: action.sampleSize,
          differentialLoading: false,
          differentialFailed: false
        }
      };
    case GET_GEO_DIFFERENTIAL_FAILED:
      return {
        ...state,
        geo: {
          ...state.geo,
          differentialFailed: true,
          differentialLoading: false
        }
      };
    case UPDATE_GEO_DIFFERENTIAL_OVERRIDE:
      return {
        ...state,
        geo: {
          ...state.geo,
          differentialOverride: action.override
        }
      };
    case UPDATE_SKILL_DIFFERENTIAL_OVERRIDE:
      return {
        ...state,
        skills: {
          ...state.skills,
          differentialOverride: action.override
        }
      };
    case SET_SELECTED_SKILL_GEO_DIFFERENTIAL_DATA:
      return {
        ...state,
        ...getInitialStateValues(action),
        hasInitializedJob: true
      };
    case GET_JOB_PRICING_SUCCESS:
      return {
        ...state,
        jobPricing: action.jobPricing,
        selectedJobPricing: action.defaultSelectedJobPricing,
        pricingFieldPk: action.pricingFieldPk
      };
    case UPDATE_SELECTED_JOB_PRICING:
      return {
        ...state,
        selectedJobPricing: action.selectedJobPricing,
        pricingFieldPk: action.pricingFieldPk
      };
    case CLEAR_GEO_DIFFERENTIAL:
      return {
        ...state,
        geo: {
          ...state.geo,
          differential: 0,
          differentialOverride: 0,
          sampleSize: null
        }
      };
    case GET_JOB_MATCHES_SUCCESS:
      let selectedJobMatches = state.selectedJobMatches;
      if (action.jobMatches && state.selectedJobMatches.length === 0) {
        selectedJobMatches = action.jobMatches.map(match => {
          return match.matchId;
        });
      }
      return {
        ...state,
        jobMatches: action.jobMatches,
        pricingType: action.pricingType,
        selectedJobMatches: selectedJobMatches,
        jobMatchesLoaded: true
      };
    case APPLY_DIFFERENTIALS_TO_JOB_MATCHES_START:
      return {
        ...state,
        applyingDifferentialsToJobMatches: true,
        applyingDifferentialsToJobMatchesFailed: false
      };
    case APPLY_DIFFERENTIALS_TO_JOB_MATCHES_FAILED:
      return {
        ...state,
        applyingDifferentialsToJobMatches: false,
        applyingDifferentialsToJobMatchesFailed: true
      };
    case APPLY_DIFFERENTIALS_TO_JOB_MATCHES_SUCCESS:
      const isGeoRemoved = state.geo.isRemoved;
      const isSkillRemoved = state.skills.isRemoved;
      const geoState = isGeoRemoved ? initialGeoState : state.geo;
      const skillState = isSkillRemoved ? initialSkillsState : state.skills;
      geoState.isApplied = !isGeoRemoved;
      skillState.isApplied = !isSkillRemoved;
      return {
        ...state,
        applyingDifferentialsToJobMatches: false,
        applyingDifferentialsToJobMatchesFailed: false,
        proposedValues: null,
        hasChanges: false,
        isDifferentialLoaded: true,
        hasPreviousDifferential: !!geoState.differential || !!skillState.differential,
        skill: {
          ...skillState
        },
        geo: {
          ...geoState
        }
      };
    case RESET_DIFFERENTIALS_TO_INITIAL_STATE:
      return {
        ...initialState
      };
    case RESET_GEO_STATE:
      return {
        ...state,
        geo: {
          ...initialGeoState
        }
      };
    case RESET_SKILLS_STATE:
      return {
        ...state,
        skills: {
          ...initialSkillsState
        }
      };
    case SET_SELECTED_JOB_FAMILY:
      return {
        ...state,
        geo: {
          ...state.geo,
          selectedJobFamily: action.selectedJobFamily
        }
      };
    case SET_SELECTED_JOB_TITLE:
      return {
        ...state,
        skills: {
          ...state.skills,
          selectedJobTitle: action.data.title,
          tasks: action.data.tasks,
          isInitialLoad: state.skills.selectedJobTitle ? false : true
        }
      };
    case SET_SELECTED_JOB_LOCATION:
      const isJobFamilyChanging = action.selectedJobFamily !== state.geo.selectedJobFamily;
      let selectedJobFamily = isJobFamilyChanging ? null : state.geo.selectedJobFamily;
      return {
        ...state,
        geo: {
          ...state.geo,
          selectedJobLocation: action.selectedJobLocation,
          selectedJobFamily: selectedJobFamily
        }
      };
    case SET_SELECTED_JOB_MATCHES:
      return {
        ...state,
        selectedJobMatches: action.selectedJobMatches
      };
    case SET_GEO_DIFFERENTIAL_IS_REMOVED:
      const location = action.isRemoved ? null : state.geo.selectedJobLocation;
      const family = action.isRemoved ? null : state.geo.selectedJobFamily;
      const geoDiff = action.isRemoved ? 0.0 : state.geo.differential;
      const geoDiffOverride = action.isRemoved ? 0.0 : state.geo.differentialOverride;
      return {
        ...state,
        geo: {
          ...state.geo,
          selectedJobFamily: family,
          selectedJobLocation: location,
          differential: geoDiff,
          differentialOverride: geoDiffOverride,
          isRemoved: action.isRemoved,
          isPendingRemove: false
        }
      };
    case SET_SKILLS_DIFFERENTIAL_IS_REMOVED:
      const skills = action.isRemoved ? [] : state.skills.selectedSkills;
      const skillDiff = action.isRemoved ? 0.0 : state.skills.differential;
      const skillDifferOverride = action.isRemoved ? 0.0 : state.skills.differentialOverride;
      return {
        ...state,
        skills: {
          ...state.skills,
          selectedSkills: skills,
          differential: skillDiff,
          differentialOverride: skillDifferOverride,
          isRemoved: action.isRemoved,
          isPendingRemove: false
        }
      };
    case SET_COMMENT:
      return {
        ...state,
        comment: action.comment
      };
    case TOGGLE_INCLUDE_COMMENT:
      return {
        ...state,
        includeComment: !state.includeComment
      };
    case CREATE_AD_HOC_JOB_START:
      return {
        ...state,
        creatingAdHocJob: true
      };
    case CREATE_AD_HOC_JOB_SUCCESS:
      return {
        ...state,
        createAdHocJobFailed: false,
        creatingAdHocJob: false,
        adHocJob: action.adHocJob
      };
    case CREATE_AD_HOC_JOB_FAILED:
      return {
        ...state,
        createAdHocJobFailed: true,
        creatingAdHocJob: false
      };
    case SET_HAS_PERFORMED_CALCULATE_ACTION:
      return {
        ...state,
        hasPerformedCalculateAction: action.hasPerformed
      };
    case CALCULATE_PROPOSED_VALUE_START:
      return {
        ...state,
        isCalculatingProposedValues: true
      };
    case CALCULATE_PROPOSED_VALUE_SUCCESS:
      return {
        ...state,
        proposedValues: action.proposedValues,
        isCalculatingProposedValues: false
      };
    case CALCULATE_PROPOSED_VALUE_FAILED:
      return {
        ...state,
        proposedValues: null,
        isCalculatingProposedValues: false
      };
    case GET_CROWD_SOURCED_TITLE_MATCH_SUCCESS:
      return {
        ...state,
        crowdSourcedTitleMatchJobFamily: action.crowdSourcedTitleMatchJobFamily,
        crowdSourcedTitle: action.crowdSourcedTitle,
        companySourcedTitle: action.companySourcedTitle,
        jobTitle: action.orgJobTitle,
        skills: {
          ...state.skills,
          selectedJobTitle: action.orgJobTitle
        }
      };
    case SET_HAS_CHANGES:
      return {
        ...state,
        hasChanges: action.hasChanges
      };
    case SET_GEO_IS_PENDING_REMOVE: {
      return {
        ...state,
        geo: {
          ...state.geo,
          isPendingRemove: action.isPending
        }
      };
    }
    case SET_SKILL_IS_PENDING_REMOVE: {
      return {
        ...state,
        skills: {
          ...state.skills,
          isPendingRemove: action.isPending
        }
      };
    }
    case SET_INCLUDE_COMMENT: {
      return {
        ...state,
        includeComment: action.includeComment
      };
    }
    case TOGGLE_SKILLS_SEARCH: {
      return {
        ...state,
        skills: {
          ...state.skills,
          showSearch: true,
          isEditing: false
        }
      };
    }
    case CANCEL_CHANGES: {
      return {
        ...initialState,
        ...getInitialStateValues(state),
        changesCancelled: true
      };
    }
    case SET_CHANGES_CANCELLED: {
      return {
        ...state,
        changesCancelled: action.changesCancelled
      };
    }
    case SEND_OPPORTUNITY_EMAIL_SUCCESS: {
      return {
        ...state,
        submitRequestSuccess: true,
        submitRequestFail: false
      };
    }
    case SEND_OPPORTUNITY_EMAIL_FAIL: {
      return {
        ...state,
        submitRequestSuccess: false,
        submitRequestFail: true
      };
    }
    case SEND_OPPORTUNITY_EMAIL_RESET: {
      return {
        ...state,
        submitRequestSuccess: false,
        submitRequestFail: false
      };
    }
    case INITIALIZE_DIFFERENTIALS_START: {
      return {
        ...state,
        isInitializingDifferentials: true
      };
    }
    case INITIALIZE_DIFFERENTIALS_SUCCESS: {
      return {
        ...state,
        isInitializingDifferentials: false
      };
    }
    case INITIALIZE_DIFFERENTIALS_FAIL: {
      return {
        ...state,
        isInitializingDifferentials: false
      };
    }
    default:
      return { ...state };
  }
}

function getInitialStateValues(state) {
  return {
    orgJobId: state.orgJobId,
    orgJobCode: state.orgJobCode,
    orgJobCodeKey: state.orgJobCodeKey,
    benchmarkYear: state.benchmarkYear,
    currency: state.currency,
    jobTitle: state.jobTitle,
    payDivisor: state.payDivisor,
    displayIn: state.displayIn ? state.displayIn : DISPLAY_IN_TYPE.ANNUAL
  };
}

function getSelectedJobFamily(currentSelectedGeoJobFamily, crowdSourcedTitleMatchJobFamily, jobFamilies) {
  if (currentSelectedGeoJobFamily) {
    return currentSelectedGeoJobFamily;
  }
  if (crowdSourcedTitleMatchJobFamily && jobFamilies && jobFamilies.length) {
    if (jobFamilies.includes(crowdSourcedTitleMatchJobFamily)) {
      return crowdSourcedTitleMatchJobFamily;
    }
  }
  return null;
}

export const skillGeoDifferentialActions = {};
